import React from 'react'
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import DescriptionIcon from "@mui/icons-material/Description";
import {useBookingFinanceDocumentCreate, useBookingFinanceDocumentPolling} from "../../query";
import LoadingButton from "@mui/lab/LoadingButton";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import SyncIcon from '@mui/icons-material/Sync';
import {dateAndTime} from "../../../../services/date/formatters";


const BookingFinanceDocument = ({booking}) => {
    const bookingFinance = booking.bookingFinance;
    const bookingFinanceDocument = bookingFinance.bookingFinanceDocument;

    const fileUrl = bookingFinanceDocument?.fileUrl;
    const downloadFileUrl = bookingFinanceDocument?.downloadFileUrl;
    const pdfStatus = bookingFinanceDocument?.pdfStatus;
    const hasOldData = bookingFinanceDocument?.hasOldData;

    const showCreateButton = !bookingFinanceDocument || pdfStatus === 'failed';

    const bookingFinanceDocumentCreate = useBookingFinanceDocumentCreate({bookingId: booking.id});

    const handleCreate = () => {
        bookingFinanceDocumentCreate.mutate({bookingId: booking.id});
    }

    const pdfCompleted = pdfStatus === 'completed';
    const pdfPending = pdfStatus === 'pending';
    const pdfFailed = pdfStatus === 'failed';

    // Polling to update the status of the document as long as it's pending
    useBookingFinanceDocumentPolling(booking.id, pdfPending);

    return <Stack direction="column" rowGap={2} alignItems="end" flexWrap="wrap" flexGrow={1}>
            <Stack alignSelf="center">
                {
                    pdfPending && <Stack direction={"row"} spacing={1} alignItems="center">
                        <Typography variant="body2">
                            Creazione documento PDF in corso...
                        </Typography>
                        <CircularProgress size={16} color="primary"/>
                    </Stack>
                }
                {
                    pdfFailed && <Typography variant="body2" color="error">
                        Generazione documento non riuscita. Riprova a creare il documento.
                    </Typography>
                }
                {
                    hasOldData && <Alert severity="warning">
                        Sono state apportate modifiche alla prenotazione dopo la creazione dell'ultimo documento. Aggiorna il documento per includere le modifiche.
                    </Alert>
                }
                {
                    (pdfCompleted && !hasOldData) && <Typography variant="body2" color="textSecondary">
                        Documento PDF creato il: {dateAndTime(bookingFinanceDocument.createdAt)}
                    </Typography>
                }
            </Stack>
            <Stack direction="row" alignItems="center" sx={{alignSelf: "flex-end", rowGap: 2, columnGap: 1}} flexWrap={"wrap"}>

                {
                    <LoadingButton color="primary"
                                   size="small"
                                   variant={showCreateButton ? "contained" : "text"}
                                   onClick={handleCreate}
                                   loading={bookingFinanceDocumentCreate.isLoading}
                                   disabled={pdfPending}
                                   startIcon={ showCreateButton ?  <DescriptionIcon/> : <SyncIcon/>}>
                        {showCreateButton ? "Crea Documento di Riepilogo" : "Aggiorna" }
                    </LoadingButton>
                }

                {
                    !showCreateButton && <Button variant="outlined"
                                                 startIcon={<FileDownloadIcon/>}
                                                 color="primary"
                                                 size="small"
                                                 href={downloadFileUrl}
                                                 rel="noopener"
                                                 disabled={!pdfCompleted || pdfPending || bookingFinanceDocumentCreate.isLoading}
                                                 target="_self">
                        Scarica
                    </Button>
                }

                {
                    !showCreateButton && <Button variant="outlined"
                            startIcon={<DescriptionIcon/>}
                            color="primary"
                            size="small"
                            href={fileUrl}
                            disabled={!pdfCompleted || pdfPending || bookingFinanceDocumentCreate.isLoading}
                            target="_blank">
                        Apri PDF
                    </Button>
                }
            </Stack>
        </Stack>
}


export default BookingFinanceDocument;